var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "modal",
      staticClass: "modal fade",
      attrs: { id: _vm.id, tabindex: "-1", role: "dialog" },
    },
    [
      _c(
        "div",
        {
          staticClass:
            "modal-dialog modal-dialog-scrollable modal-dialog-centered",
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c("div", { staticClass: "modal-title h3" }, [
                _vm._v("\n          " + _vm._s(_vm.title) + "\n        "),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "close",
                  attrs: {
                    type: "button",
                    "data-dismiss": "modal",
                    "aria-hidden": "true",
                  },
                },
                [_vm._v("\n          ×\n        ")]
              ),
            ]),
            _vm._v(" "),
            !_vm.description
              ? _c(
                  "div",
                  { staticClass: "modal-body" },
                  [_c("loading-animation", {})],
                  1
                )
              : _c("div", {
                  staticClass: "modal-body",
                  domProps: { innerHTML: _vm._s(_vm.description) },
                }),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }